import React, { useState, useEffect } from "react";
import axios from "axios";

const AwardImages = () => {
  const [images, setImages] = useState([]);
  const [selectedImg, setSelectedImage] = useState(null);
  const [selectedText, setSelectedText] = useState("");
  const [selectedContent, setSelectedContent] = useState("");

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get("https://skpbackend.quindl.com/gallery/award");
        const data = response.data;
        const formattedData = data.map((item, index) => ({
          id: index + 1,
          src: `https://skpbackend.quindl.com${item.location}`,
          alt: `Award Image ${index + 1}`,
          text: item.title,
          content: item.content,
        }));
        setImages(formattedData);
      } catch (error) {
        console.error("Error fetching award images:", error);
      }
    };

    fetchImages();
  }, []);

  const openImage = (src, text, content) => {
    setSelectedImage(src);
    setSelectedText(text);
    setSelectedContent(content);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setSelectedText("");
    setSelectedContent("");
  };

  return (
    <div className="image-container award-container">
      {images.map((img) => (
        <div key={img.id} className="image-wrapper">
          <div className="image-text">{img.text}</div>
          <img
            src={img.src}
            alt={img.alt}
            className="carousel-image"
            onClick={() => openImage(img.src, img.text, img.content)}
          />
        </div>
      ))}

      {selectedImg && (
        <div className="full-img-overlay" onClick={closeImage}>
          <div>
            <h3>{selectedText}</h3>
            <p>{selectedContent}</p>
          </div>
          <img
            src={selectedImg}
            alt="Full Screen"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </div>
  );
};

export default AwardImages;
